import { get, map, mapValues } from 'lodash'
import { getReq } from '../../utils/request'
import { formatDateWithTime } from '../../utils/helper'
import {
	IStoreItemTransactionsPayload,
	StoreItemTransactionOriginalItem,
	StoreItemTransactionTableItem
} from '../../pages/storeItemTransactions/types'

const fetchStoreItemTransactionsList = async (params: any = {}) => {
	const queries = {
		limit: 20,
		page: 1,
		...params
	}

	const normalizeQueryParams = mapValues(queries, (query) => (query === false ? false : (query || undefined)))
	const { data } = await getReq('/api/admin/store-item-transactions', normalizeQueryParams)

	const originalData: StoreItemTransactionOriginalItem[] = get(data, 'storeItemTransactions', [])
	const tableData: StoreItemTransactionTableItem[] = map(originalData, (column) => ({
		key: column.id,
		id: column.id,
		amount: column.amount,
		type: column.type,
		storeItemName: column.storeItemName || null,
		jobFromName: column.jobFrom?.name || null,
		jobToName: column.jobTo?.name || null,
		userExecutorName: column.userExecutor?.name || null,
		createdAt: formatDateWithTime(column.createdAt)
	}))

	return {
		tableData,
		originalData,
		pagination: get(data, 'context')
	} as IStoreItemTransactionsPayload
}

export default fetchStoreItemTransactionsList
